import { forwardRef } from 'react';
import { Collapse } from '@material-ui/core';
import cx from 'classnames';
import PropTypes from 'prop-types';

import { ChevronIcon } from 'src/components/ChevronIcon';
import { CustomButtonBase } from 'src/components/CustomButtonBase';
import { PanelTitle } from 'src/components/PanelTitle';
import { ROTATE_DIRECTION } from 'src/data/ui';

import { useStyles } from './useStyles';

export const CollapsiblePanel = forwardRef(
  ({ className, classes, title, titleModified, expanded, onToggle, children }, ref) => {
    const styles = useStyles({ classes });

    return (
      <div
        className={cx(styles.root, className, {
          [styles.expanded]: expanded,
        })}
        ref={ref}
      >
        {title && (
          <CustomButtonBase
            className={styles.button}
            onClick={onToggle}
          >
            <PanelTitle
              className={styles.title}
              title={title}
              modified={titleModified}
            />

            <ChevronIcon
              className={styles.chevronIcon}
              direction={expanded ? ROTATE_DIRECTION.up : ROTATE_DIRECTION.down}
            />
          </CustomButtonBase>
        )}

        <Collapse
          className={styles.collapse}
          in={expanded}
        >
          <div className={styles.childrenWrapper}>{children}</div>
        </Collapse>
      </div>
    );
  }
);

CollapsiblePanel.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  title: PropTypes.string,
  children: PropTypes.node,
  titleModified: PropTypes.bool,
  expanded: PropTypes.bool,
  onToggle: PropTypes.func,
};
CollapsiblePanel.defaultProps = {
  className: '',
  classes: null,
  title: '',
  children: null,
  titleModified: false,
  expanded: false,
  onToggle: null,
};
